import moment from "moment";

const toNumber = (value) => Number(value || 0);

/**
 * Merge multiple data series by date, filling gaps with zeros.
 * Each series config: { dataKey, field, name }
 *   - dataKey: key in the overview object (e.g. "messages_sent")
 *   - field: which field to read (e.g. "actions" or "actions_unique")
 *   - name: output property name in the merged data point
 */
export function mergeSeriesByDate(overview, seriesConfig, startDate, endDate) {
  const start = moment(startDate, "YYYY-MM-DD");
  const end = moment(endDate, "YYYY-MM-DD");
  const days = end.diff(start, "days") + 1;
  const result = [];

  for (let i = 0; i < days; i++) {
    const date = moment(startDate).add(i, "days");
    const dateStr = date.format("YYYY-MM-DD");
    const displayDate = date.format("MMM D");
    const point = { date: displayDate };

    seriesConfig.forEach(({ dataKey, field, name }) => {
      const arr = overview[dataKey] || [];
      const entry = arr.find((d) => d.action_date === dateStr);
      point[name] = entry ? toNumber(entry[field]) : 0;
    });

    result.push(point);
  }

  return result;
}

export function computeKPI(data, field = "actions") {
  if (!data || !data.length) return { total: 0, trend: 0, dailyAvg: 0 };

  const total = data.reduce((sum, d) => sum + toNumber(d[field]), 0);
  const dailyAvg = data.length > 0 ? (total / data.length).toFixed(1) : 0;

  const mid = Math.floor(data.length / 2);
  const firstHalf = data.slice(0, mid).reduce((s, d) => s + toNumber(d[field]), 0);
  const secondHalf = data.slice(mid).reduce((s, d) => s + toNumber(d[field]), 0);
  const trend =
    firstHalf > 0
      ? Math.round(((secondHalf - firstHalf) / firstHalf) * 100)
      : secondHalf > 0
        ? 100
        : 0;

  return { total, trend, dailyAvg };
}
